export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-scale/src/number.js
// module id = ../../../../d3-scale/src/number.js
// module chunks = vendor